import React from "react";
import { FlexibleImageGridProps } from "../../../../types/flexible-sets";
import { IMappedArticle, IMappedFlexibleSet } from "../../../../types/suggestion-items";
import PlusIcon from "../../../../Assets/svg/Plus_icon";
import "./flexible-image-grid.scss";

const FlexibleImageGrid = (props: FlexibleImageGridProps) => {
    const renderArticleImage = (article: IMappedArticle) => {
        return (
            <div key={0} className={`article-image-${0}`}>
                <img src={article.image} alt={props.imageMainView} data-set-index={0} />
            </div>
        );
    };

    const renderSetImages = (set: IMappedFlexibleSet) => {
        const showPlusIcon = !set.flexibleSetImage && set.brickItems.length > 4;

        return (
            <>
                {set.flexibleSetImage
                    ? renderSetImage(set.flexibleSetImage, set.title, 0)
                    : set.brickItems
                          .slice(0, showPlusIcon ? 3 : 4)
                          .map((b, index) => renderSetImage(b.articleImage, b.articleName, index))}
                {showPlusIcon && (
                    <div className="svg-container">
                        <div className="bg-circle">
                            <PlusIcon />
                        </div>
                    </div>
                )}
            </>
        );
    };

    const renderSetImage = (image: string, title: string, index: number) => {
        return (
            <div key={index} className={`article-image-${index}`}>
                <img src={image} alt={`${props.imageMainView}, ${title}`} data-set-index={index} />
            </div>
        );
    };

    return (
        <div className="ssw-flexible-image-grid eyeAbleContrastSkip">
            {props.article && renderArticleImage(props.article)}
            {props.set && renderSetImages(props.set)}
        </div>
    );
};

export default FlexibleImageGrid;
